import {
  COMPANY_CHANGED,
  LOGOUT,
  SET_COMPANY,
  SET_USER_INFO,
  SET_UPDATED_USER_INFO,
  SET_IS_LOGGED_IN,
  SET_INTENT,
} from 'store/constants';
import { IUserData } from '../types';
import { ICompany } from 'types/Company.types';
import { IEditUserData } from 'pages/ProfilePage/hooks';
import { IIntent } from 'types/Intent.types';

export const setUserInfo = (userData: IUserData) => ({
  type: SET_USER_INFO,
  payload: userData,
});

export const logout = () => ({
  type: LOGOUT,
});

export const companyChanged = () => ({
  type: COMPANY_CHANGED,
});

export const setCompany = (company: ICompany | null) => ({
  type: SET_COMPANY,
  payload: company,
});

export const setUpdatedUserInfo = (userData: IEditUserData) => ({
  type: SET_UPDATED_USER_INFO,
  payload: userData,
});

export const setIsLoggedIn = (isLoggedIn: boolean) => ({
  type: SET_IS_LOGGED_IN,
  payload: isLoggedIn,
});

export const setIntent = (intent: IIntent | null) => ({
  type: SET_INTENT,
  payload: intent,
});
